import CountriesIcon from '../assets/images/3M_countries.svg';
import AgeGroupsIcon from '../assets/images/3M_agegroups_gray.svg';
import GenderIcon from '../assets/images/3M_gender.svg';
import IncomeIcon from '../assets/images/3M_income_gray.svg';
import EmploymnentIcon from '../assets/images/3M_employment_gray.svg';
import LocationTypeIcon from '../assets/images/3M_urban_gray.svg';

// console.log(CountriesIcon);

const FilterGroupings = [
  {
    eventKey: '0',
    label: 'filter_cntry',
    field: 'country',
    program_num: 'Countries',
    icon: CountriesIcon,
  },
  {
    eventKey: '1',
    label: 'filter_age',
    field: 'generation',
    program_num: 'AgeGroup',
    icon: AgeGroupsIcon,
  },
  {
    eventKey: '2',
    label: 'filter_gnder',
    field: 'gender',
    program_num: 'resp_gender',
    icon: GenderIcon,
  },
  {
    eventKey: '3',
    label: 'filter_income',
    field: 'income',
    program_num: 'Income',
    icon: IncomeIcon,
  },
  {
    eventKey: '4',
    label: 'filter_emp',
    field: 'employment',
    program_num: 'Employment',
    icon: EmploymnentIcon,
  },
  {
    eventKey: '5',
    label: 'filter_loc',
    field: 'loc',
    program_num: 'URB_RUR',
    icon: LocationTypeIcon,
  },
  {
    eventKey: '6',
    label: 'filter_econ',
    field: 'developed',
    program_num: 'Developed',
    icon: CountriesIcon,
  },
];

export default FilterGroupings;
